module.exports = __webpack_public_path__ + "f410ba5cb694d747a9454b6295df7f2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-27.png
// module id = 1982
// module chunks = 0